var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lv_flexalign_center act_layout"},[_c('div',{staticClass:"act_button",class:{ actived: _vm.actived === 1 },on:{"click":function($event){_vm.actived = 1;
      _vm.open(true);}}},[_vm._v(" 开启 ")]),_c('div',{staticClass:"act_button",class:{ actived: _vm.actived === 2 },on:{"click":function($event){_vm.actived = 2;
      _vm.open(false);}}},[_vm._v(" 关闭 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }